import { render, staticRenderFns } from "./TechnologiesWidget.vue?vue&type=template&id=0d00b74e&scoped=true"
import script from "./TechnologiesWidget.vue?vue&type=script&lang=js"
export * from "./TechnologiesWidget.vue?vue&type=script&lang=js"
import style0 from "./TechnologiesWidget.vue?vue&type=style&index=0&id=0d00b74e&prod&lang=scss&scoped=true"
import style1 from "./TechnologiesWidget.vue?vue&type=style&index=1&id=0d00b74e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d00b74e",
  null
  
)

export default component.exports